import { render } from "./GapBlock.vue?vue&type=template&id=c65de770"
import script from "./GapBlock.vue?vue&type=script&lang=js"
export * from "./GapBlock.vue?vue&type=script&lang=js"

import "./GapBlock.vue?vue&type=style&index=0&id=c65de770&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__